import React, { useState } from "react";
import { FaSearch } from "react-icons/fa";
import { getAccountInfo } from "../../../methods/contracts/getBalance";
import "./styles.css";
import styled, { useTheme } from "styled-components";

const LabelValueContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 10px 0;
`;

const Label = styled.span`
  font-size: 14px;
  font-weight: 500;
  line-height: 16.8px;
  color: ${({ theme }) => theme.white};
`;

const InputSelect = ({
  options,
  value,
  onChange,
  onInputChange,
  placeholder,
  walletAddress,
  disabled,
  label,
}) => {
  const [inputValue, setInputValue] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const theme = useTheme();
  
  // InputSelect component for token selection

  const getAddressInfo = async (value) => {
    console.log(walletAddress, value);
    let { decimals, symbol, walletBalance } = await getAccountInfo(
      value,
      walletAddress
    );
    if (value && symbol) {
      onChange({
        tokenAddress: value,
        symbol: symbol,
        decimal: decimals,
        balance: walletBalance.toFixed(4),
      });
    }
  };

  const handleInputChange = async (event) => {
    const value = event?.target?.value;
    setInputValue(value);
    await getAddressInfo(value);
  };

  const handleOptionSelect = (option) => {
    setInputValue(option?.tokenAddress);
    onChange(option);
    setShowDropdown(false);
  };

  return (
    <div style={{ width: "100%" }}>
      <LabelValueContainer>
        <Label>{label}</Label>
      </LabelValueContainer>
      <div
        className="inputSelectContainer"
        style={{ 
          opacity: disabled ? "0.5" : "1",
          cursor: disabled ? "not-allowed" : "pointer"
        }}
        onClick={() => {
          if (!disabled) {
            setShowDropdown(true);
          }
        }}
      >
        <FaSearch />
        {/* Dropdown indicator */}
        {/* {options?.length > 0 && !disabled && (
          <div style={{ 
            fontSize: "12px", 
            color: theme.greenLight,
            marginLeft: "8px",
            opacity: 0.7
          }}>
            ({options.length} tokens)
          </div>
        )} */}
        <input
          type="text"
          className="input"
          value={inputValue}
          onChange={handleInputChange}
          placeholder={placeholder}
          onFocus={() => setShowDropdown(true)}
          onClick={() => setShowDropdown(true)}
          onBlur={() => {
            // Delay hiding dropdown to allow option clicks
            setTimeout(() => setShowDropdown(false), 200);
          }}
          disabled={disabled}
          style={{ color: theme.text }}
        />
        {showDropdown && options?.length > 0 && (
          <div
            className="dropdown"
            style={{
              backgroundColor: theme.body,
              borderColor: theme.greenLight,
              color: theme.text,
              overflowY: "auto",
              maxHeight: "200px"
            }}
            onMouseDown={(e) => e.preventDefault()} // Prevent input blur when clicking dropdown
          >
            <div style={{ 
              padding: "8px 12px", 
              fontSize: "12px", 
              color: theme.greenLight,
              borderBottom: `1px solid ${theme.greenLight}`
            }}>
              Select a token:
            </div>
            {options?.map((token, index) => (
              <div
                key={token?.tokenAddress || index}
                className="dropdownOption"
                onClick={() => handleOptionSelect(token)}
                style={{
                  color: theme.text,
                  borderBottom: index < options.length - 1 ? `1px solid ${theme.greenLight}20` : 'none'
                }}
              >
                <div style={{ fontWeight: "bold" }}>
                  {token?.symbol}
                  {token?.source && (
                    <span style={{ 
                      fontSize: "10px", 
                      opacity: 0.6, 
                      marginLeft: "8px",
                      backgroundColor: theme.greenLight + "20",
                      padding: "2px 4px",
                      borderRadius: "4px"
                    }}>
                      {token.source}
                    </span>
                  )}
                </div>
                <div style={{ fontSize: "12px", opacity: 0.8 }}>
                  Balance: {token?.balance} | {token?.tokenAddress?.substring(0, 10)}...
                  {token?.chainId && (
                    <span style={{ marginLeft: "8px", opacity: 0.6 }}>
                      Chain: {token.chainId}
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default InputSelect;
